import "../css/fonts.css"
import "../css/style.scss"
import "../css/responsive.scss"
import React from 'react'
import Header from "../components/header"
import Footer from "../components/footer"
import Helmet from "react-helmet"
import { withPrefix } from "gatsby" 

const DefaultTemplate = ({ children }) => (
    <div>
      <Helmet>
        <script src={withPrefix('studio137.js')} type="text/javascript" />
      </Helmet>
      <Header />
      { children }
      <Footer />
    </div>
  )
  
export default DefaultTemplate
  
   
